<div class="super-container">
  <lib-modal-header class="timeline-header" (close)="close()">
    {{ "nouns.timeline-patient" | translate | uppercase }}
  </lib-modal-header>
  <lib-modal-body>
    <div #supersetContainer id="supersetContainer" class="timeline-container"></div>
  </lib-modal-body>
</div>
